/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/lodash@4.17.21/~/lodash/_freeGlobal.js
// module id = 188
// module chunks = 0